/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
    Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm} from 'react-redux-form';
import swal from 'sweetalert';
import { ClipLoader } from 'react-spinners';
import PaymentIcon from 'react-payment-icons';
import creditCardType, { getTypeInfo, types as CardType } from 'credit-card-type';

import AccountStore from '../../../stores/account-store';
import ItemModal from '../modals/customModal';
import Api from '../../../services/reservationapi';
// import ErroModal from './errorModal';
// import NabVelocity from "react-nab-velocity-checkout";
import NabVelocity from '../../sub-components/nab/nabVelocity'

var XMLParser = require('react-xml-parser');

class ChargeJumper extends Component {

    constructor(props) {

        super(props);
        this.PayLoadId = '';
        this.chargeMemo = '';
        this.PayLoadAmount = '';
        // this.paymentType = ["Credit", "Debit", "Cash", "Card on file"];
        this.cardDigit = '';
        this.jumperId = '';
        this.state = {
            isModalOpen: false,
            isSelected: false,
            isCardProcessing: false,
            errors: {},
            amount: '',
            isloading: false,
            errorOpen: false,
            showCredit: false,
            memo: "",
            cardType: '',
            cardNumber: '',
            cardHolder: '',
            expire: '',
            cvv: '',
            selYear: '',
            selMonth: '',
            cardIcon: '',
            transactionId: ''
        };
        this.orderIdQueue=[];
        this.accountEvents = [
            {
                name: AccountStore.getEventPrefix('chargeCompleted'), func: this.handleChargeCompleted
            }
        ];
    }

    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


    toggleModal=(e)=> {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            isloading: false
            //jumpType: null
        });
    }

    changeRadio=(e)=> {
        var value = e.target.value;
        if (value === "Card key in") {
            this.setState({ checkedRadio: e.target.value, showCredit: false });
        }
        else {
            this.setState({ checkedRadio: e.target.value, showCredit: false });
        }
    }

    handleChargeCompleted=(value) =>{
        if (value === false) {
            this.setState({
                errorOpen: true,
                isloading: false
            })
        }
        else {
            this.setState({
                isloading: false
            })
        }
    }

    handleYearSelect = (event) => this.setState({ selYear: event.target.value.slice(-2) })

    handleMonthSelect = (event) => {
        var month = parseInt(event.target.value);
        if (month > 9) {
            month = month.toString();
        } else {
            month = '0' + month.toString();
        }
        this.setState({ selMonth: month })
    };

    // componentWillMount = () => {

    //     var aScript = document.createElement('script');
    //     aScript.type = 'text/javascript';
    //     aScript.src = "https://api.cert.nabcommerce.com/1.3/button.js";
    //     aScript.setAttribute('id', 'velocityScript');
    //     document.head.appendChild(aScript);
    // }

    componentWillUnmount() {
        this.accountEvents.forEach((evnt) => AccountStore.removeListener(evnt.name, evnt.func));
    }

    componentDidMount() {
        this.accountEvents.forEach((evnt) => AccountStore.on(evnt.name, evnt.func));
    }

    handleSubmit=(values)=> {
        //console("in handle charge jumper");
        this.setState({ isloading: true })

        //this.toggleModal();
        var payload = {};
        var jumperId = this.props.jumperId;
        // alert(jumperId);
        payload.amount = values.amount;
        payload.isRefund = false;
        payload.transactionType = this.state.paymentType;

        if (this.props.isTandemStudent) {
            payload.isTandemStudent = this.props.isTandemStudent;
        }
        if (values.memo !== "")
            payload.memo = values.memo


        if (this.state.errors.amount !== "" && Object.keys(this.state.errors).length > 0) {
            console.log(this.state.errors);
            alert('error');
            this.setState({ isloading: false });
            return;
        }

        if(values.amount < 0.00 && (this.state.paymentType === 'Cash' || this.state.paymentType === 'Credit' || this.state.paymentType === 'Debit' || this.state.paymentType === "Check" || this.state.paymentType ==="Card Key In")){
            swal(
                    {
                        title: "Validation error",
                        text: "charge value must be positive",
                        icon: "error",
                    }
                )
                this.setState({ isloading: false });

        }
        else if(values.amount >= 0.00 && (this.state.paymentType === "Cash Payout" || this.state.paymentType === "Check Payout" || (this.state.paymentType.indexOf("Account-") > -1) )){
            swal(
                    {
                        title: "Validation error",
                        text: "payout value must be negative",
                        icon: "error",
                    }
                )
                this.setState({ isloading: false });

        }
        //console(this.state.paymentType);
        else if(window.ENV?.terminalEnabled && (this.state.paymentType === 'Credit' || this.state.paymentType === 'Debit')) {
            if (window.ENV?.processorInfo.processor === "nab") {
                AccountStore.TerminalAuthorizeAndCapture(this.state.paymentType, values.amount)
                    .then(result => {

                        //console('printing result');
                        console.log(result);

                        var xml = new XMLParser().parseFromString(result);    // Assume xmlText contains the example XML
                        //console(xml);
                        payload.amount = values.amount;
                        payload.transactionType = this.state.paymentType;


                        const resp_text = xml.getElementsByTagName('AUTH_RESP_TEXT')[0].value;
                        if (resp_text.includes("APPROVAL") || resp_text.includes("APPROVED")) {
                            payload.transactionId = xml.getElementsByTagName('AUTH_GUID')[0].value;
                            payload.maskedCardNum = xml.getElementsByTagName('AUTH_MASKED_ACCOUNT_NBR')[0].value;
                            payload.transactionDateTime = xml.getElementsByTagName('AUTH_TRAN_DATE_GMT')[0].value;
                            return AccountStore.ChargeJumper(jumperId, payload);
                        }
                        else {
                        	payload.amount = 0.00;
                            payload.transactionType = this.state.paymentType;
                            payload.memo = "DECLINED";
                        	return AccountStore.ChargeJumper(jumperId, payload);
                            //console("error");
                        }
                        this.setState({ isloading: false });
                    })
                    .then(result => {
                        //console('jumper charged');
                        this.toggleModal();
                        this.setState({ isloading: false });
                    })
            }
            else if(window.ENV?.processorInfo.processor === "transnational"){
                console.log(values.amount);
                this.setState({ isCardProcessing: true });
                var orderId = Math.floor(100000 + Math.random() * 900000);
                this.orderIdQueue.push(orderId);
                AccountStore.TransnationalTerminalTransaction(values.amount * 100, orderId.toString())
                    .then(result => {

                        console.log('printing result');
                        console.log(result);
                        //console(xml);
                        payload.amount = values.amount;
                        payload.transactionType = this.state.paymentType;

                        if (result.data.response === "approved") {
                            payload.transactionId = result.data.id;
                            payload.maskedCardNum = result.data.response_body.terminal.masked_card;
                            payload.cardholderName = result.data.response_body.terminal.cardholder_name;
                            return AccountStore.ChargeJumper(jumperId, payload);
                        }
                        else if (result.data.response === "declined" || result.data.response === "unknown") {
                            setTimeout(() => {
                                AccountStore.TransnationalTerminalTransactionSearch(
                                    {
                                        "order_id": {
                                            "operator": "=",
                                            "value": orderId.toString()
                                        }
                                    })
                                    .then(rt => {
                                        console.log(rt);
                                        var tr = rt.data.filter(t => t.response === "approved")[0];

                                        if (tr !== undefined) {
                                            payload.transactionId = tr.id;
                                            payload.maskedCardNum = tr.response_body.terminal.masked_card;
                                            payload.cardholderName = tr.response_body.terminal.cardholder_name;
                                            return AccountStore.ChargeJumper(jumperId, payload);
                                        }
                                        else{
                                        	payload.transactionId = tr.id;
                                            payload.maskedCardNum = tr.response_body.terminal.masked_card;
                                            payload.cardholderName = tr.response_body.terminal.cardholder_name;
                                            payload.memo = "FAILED";
                                            payload.amount = 0.00;
                                            return AccountStore.ChargeJumper(jumperId, payload);
                                        }
                                    })
                            }, 35000);

                        }
                        /*
                        if (resp_text.includes("APPROVAL")) {
                            payload.transactionId = xml.getElementsByTagName('AUTH_GUID')[0].value;
                            return AccountStore.ChargeJumper(jumperId, payload);
                        }
                        else {
                            //console("error");
                        }
                        */
                        this.setState({ isloading: false, isCardProcessing: false });
                    })
                    .then(result => {
                        //console('jumper charged');
                        this.toggleModal();
                        this.setState({ isloading: false, isCardProcessing: false });
                    })
            }
        }
        // else if(this.state.paymentType === 'Card on file')
        else if (this.state.paymentType === 'Cash' || this.state.paymentType === 'Credit' || this.state.paymentType === 'Debit' || this.state.paymentType === "Check" || this.state.paymentType === "Cash Payout" || this.state.paymentType === "Check Payout") {
            AccountStore.ChargeJumper(jumperId, payload)
                .then(result => {
                    //console('done charging jumper');
                    //console(result);
                    this.toggleModal();
                    this.setState({ isloading: false });
                });
        }
        else if (this.state.paymentType === "Card key in") {
            // document.getElementById("btn_CardkeyIn").setAttribute("data-amount", values.amount);
            // document.getElementById("btn_CardkeyIn").click();

            if (window.ENV?.processorInfo.processor === "nab") {
                this.PayLoadId = jumperId;
                this.chargeMemo = values.memo;
                this.PayLoadAmount = values.amount;
                this.jumperId = jumperId;
                document.getElementsByClassName("velocity-button")[0].setAttribute("data-amount", values.amount);
                document.getElementsByClassName("velocity-button")[0].click();
            }
            else if (window.ENV?.processorInfo.processor === "transnational") {
                window.transactionUI("charge");
                var modal = document.getElementById("myModal");

                // Get the button that opens the modal
                var btn = document.getElementById("myBtn");

                // Get the <span> element that closes the modal
                var span = document.getElementsByClassName("close")[0];

                // When the user clicks the button, open the modal
                // btn.onclick = function () {˚
                modal.style.display = "block";
                // }

                // When the user clicks on <span> (x), close the modal
                span.onclick = function () {
                    modal.style.display = "none";
                }
                window.chargeComponent = this;

                // When the user clicks anywhere outside of the modal, close it
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                }
            }
            else if (window.ENV?.processorInfo.processor == "cardConnect") {

                window.initializeCardConnect("charge");
                var modal = document.getElementById("myModalCardConnect");
                modal.style.display = "block";
                window.chargeComponent = this;
            }


            // this.cardDigit = this.state.cardNumber;
            // var tokenBody = {
            //     Month: this.state.selMonth,
            //     year: this.state.selYear,
            //     Cvv: values.cvv,
            //     cardNumber: this.state.cardNumber,
            //     fullName: values.fullName,
            //     cardType: this.state.cardType,
            //     amount: values.amount
            // }


            // var body = AccountApi.createCardAuthorizeCaptureBody(tokenBody);
            // var response = Api.authorizeAndCapture(reservationStore.getTokenVal(), reservationStore.getServiceId(), body).then(this.processPaymentResponse);

        }
        else if (this.state.paymentType.indexOf("Account-") > -1) {
            var accountOnFile = this.props.accountOnFile && this.props.accountOnFile.length > 0 ? this.props.accountOnFile[this.props.accountOnFile.length - 1] : null;
            if (accountOnFile != null) {
                this.PayLoadId = jumperId;
                let payLoad = {
                    "action": "credit",
                    "authorization_amount": parseFloat(values.amount.replace('-','')),
                    "paymethod_token": accountOnFile.paymethodToken
                }
                this.setState({
                    amount:values.amount
                })
                var response = Api.ForteAchTransaction(payLoad).then(this.processPaymentResponse)
            }
        }
        else {
            var token = this.props.token;
            var Amount = values.amount;
            if (token != undefined && token.length > 0) {
                this.setState({
                    paymentType: "Card On File"
                })
                if (window.ENV?.processorInfo.processor == 'nab') {
                    var tokenParam = token[token.length - 1].token;

                    var payload = {
                        token: tokenParam,
                        amount: Amount,
                    }
                    this.PayLoadId = jumperId;
                    this.PayLoadAmount = Amount;

                    // // var body = this.createAuthorizeCaptureBody(payload);
                    // var body = AccountApi.createAuthorizeCaptureBody(payload);

                    // //console(body);
                    // var response = Api.authorizeAndCapture(reservationStore.getTokenVal(), reservationStore.getServiceId(), body).then(this.processPaymentResponse);
                    var body = payload;

                    //console(body);
                    var response = Api.authorizeAndCapture("charge",body).then(this.processPaymentResponse);
                }
                else if (window.ENV?.processorInfo.processor == 'transnational') {
                    this.PayLoadId = jumperId;
                    this.chargeMemo = values.memo;
                    var tokenParam = token[token.length - 1];
                    var payload = {
                        "type": "sale",
                        "currency": "USD",
                        "amount": parseFloat(Amount) * 100,
                        "payment_method": {
                            "customer": {
                                "id": tokenParam.customerId,
                                "payment_method_type": "card",
                                "payment_method_id": tokenParam.cardId
                            }
                        }
                    }
                    var response = Api.transnationalTransaction(payload).then(this.processPaymentResponse);
                }
                else if (window.ENV?.processorInfo.processor == 'cardConnect') {
                    this.PayLoadId = jumperId;
                    this.chargeMemo = values.memo;
                    var tokenParam = token[token.length - 1];
                    var payload = {
                        "profile": tokenParam.customerId,
                        "amount": Amount,
                        "currency": "USD",
                        "ecomind": "T"
                    }
                    var response = Api.cardConnetcAuthTransaction(payload).then(res => {
                        if (res) {
                            var captureBody = {
                                "retref": res.data.retref
                            }
                            return Api.cardConnetcCaptureTransaction(captureBody);
                        }
                        return null;
                    }).then(this.processPaymentResponse);
                }

                this.setState({ isloading: true });
            }
            else {
                this.toggleModal();
                this.setState({ isloading: false });
            }
        }
    }


    // createAuthorizeCaptureBody = (payload) => {
    //     var amount = "20.00"
    //     return {
    //         "$type": "AuthorizeAndCaptureTransaction,http://schemas.ipcommerce.com/CWS/v2.0/Transactions/Rest",
    //         SessionToken: reservationStore.getTokenVal(),
    //         ApplicationProfileId: reservationStore.getApplicationProfileId(),
    //         MerchantProfileId: reservationStore.getMerchantProfileId(),
    //         Transaction: {
    //             "$type": "BankcardTransaction,http://schemas.ipcommerce.com/CWS/v2.0/Transactions/Bankcard",
    //             TenderData: {
    //                 PaymentAccountDataToken: payload.token
    //             },
    //             TransactionData: {
    //                 Amount: payload.amount,
    //                 CurrencyCode: "USD",
    //                 TransactionDateTime: new Date().toISOString(),
    //                 CustomerPresent: "Ecommerce",
    //                 EmployeeId: "12345",
    //                 EntryMode: "Keyed",
    //                 OrderNumber: "12345",
    //                 SignatureCaptured: false,
    //             }
    //         }
    //     }
    // }

    // createCardAuthorizeCaptureBody = (tokenBody) => {
    //     //var amount = "17.00"
    //     var expiry = tokenBody.Month + tokenBody.year;
    //     return {
    //         "$type": "AuthorizeAndCaptureTransaction,http://schemas.ipcommerce.com/CWS/v2.0/Transactions/Rest",
    //         SessionToken: reservationStore.getTokenVal(),
    //         ApplicationProfileId: reservationStore.getApplicationProfileId(),
    //         MerchantProfileId: reservationStore.getMerchantProfileId(),
    //         Transaction: {
    //             "$type": "BankcardTransaction,http://schemas.ipcommerce.com/CWS/v2.0/Transactions/Bankcard",
    //             TenderData: {
    //                 PaymentAccountDataToken: null,
    //                 SecurePaymentAccountData: null,
    //                 CardData: {
    //                     CardType: tokenBody.cardType,//this.state.cardType.toString(), //visa
    //                     CardholderName: tokenBody.fullName,
    //                     PAN: tokenBody.cardNumber,//this.state.cardNumber.toString(), // 4000000000000002
    //                     Expire: expiry,  // 1220
    //                 },
    //                 CardSecurityData: {
    //                     AVSData: {
    //                         CardholderName: tokenBody.fullName,
    //                     },
    //                     CVDataProvided: "Provided",
    //                     CVData: tokenBody.Cvv,
    //                 }
    //             },
    //             TransactionData: {
    //                 Amount: tokenBody.amount,
    //                 CurrencyCode: "USD",
    //                 TransactionDateTime: new Date().toISOString(),
    //                 CustomerPresent: "Ecommerce",
    //                 EmployeeId: "12345",
    //                 EntryMode: "Keyed",
    //                 OrderNumber: "12345",
    //                 SignatureCaptured: false,
    //             }
    //         }
    //     }
    // }

    processPaymentResponse = (r) => {
    // console.log("🚀 ~ file: ChargeJumper.js ~ line 512 ~ ChargeJumper ~ r", r)

        if (this.state.paymentType.indexOf('Account-') > -1) {
            if (r.status == 200 && r.data.response.response_code == 'A01') {
                var payload = {};
                var jumperId = this.PayLoadId;
                payload.amount = parseFloat(this.state.amount);
                payload.transactionId = r.data.transaction_id;
                payload.transactionType = this.state.paymentType;
                payload.forteAuthorizationCode = r.data.response.authorization_code;
                payload.memo = this.chargeMemo;
                payload.isPayout = true;
                AccountStore.ChargeJumper(jumperId, payload);
                this.toggleModal();
                this.setState({ isloading: false });
                swal(
                    {
                        title: "Success",
                        text: "Payout From Jumper Sucessfully Done",
                        icon: "success",
                    }
                )
            } else {
                swal(
                    {
                        title: "Failed",
                        text: "Payout From Jumper Failed",
                        icon: "error",
                    }
                )
                console.log('check transaction response');
                console.log(r.data);
            }
        }
        else {
            if (window.ENV?.processorInfo.processor == 'nab' && r.data !== undefined && r.data.Status === "Successful") {

                var payload = {};
                var jumperId = this.PayLoadId;
                payload.amount = parseInt(this.PayLoadAmount);
                payload.transactionId = r.data.TransactionId;
                payload.transactionType = this.state.paymentType;
                payload.memo = this.chargeMemo;
                if (this.props.isTandemStudent) {
                    payload.isTandemStudent = this.props.isTandemStudent;
                }
                AccountStore.ChargeJumper(jumperId, payload);
                this.toggleModal();
                this.setState({ isloading: false });
            }
            else if (window.ENV?.processorInfo.processor == 'transnational' && r.status == "success" && r.data.status == "pending_settlement") {
                // debugger;
                var payload = {};
                var jumperId = this.PayLoadId;
                // console.log("🚀 ~ file: ChargeJumper.js ~ line 566 ~ ChargeJumper ~ jumperId", jumperId)
                // console.log("JUMPEID: ", this.props.jumperId)
                jumperId = this.props.jumperId;

                payload.amount = parseFloat(r.data.amount) / 100;
                payload.transactionId = r.data.id;
                payload.transactionType = this.state.paymentType;
                payload.memo = this.chargeMemo;
                payload.maskedCardNum = r.data.response_body.card.masked_card;
                if (this.props.isTandemStudent) {
                    payload.isTandemStudent = this.props.isTandemStudent;
                }
                AccountStore.ChargeJumper(jumperId, payload);
                this.toggleModal();
                this.setState({ isloading: false });

            }
            else if (window.ENV?.processorInfo.processor === 'cardConnect' && r.data && r.data.resptext === "Approval" || r.resptext === "Approval") {
                console.log('CARDCONNECTAPI: ', this.chargeMemo);
                var payload = {};
                var jumperId = this.PayLoadId ? this.PayLoadId : this.props.jumperId;;
                payload.amount = Number(r.data && r.data.amount ? r.data.amount : r.amount);
                payload.transactionId = r.data && r.data.retref ? r.data.retref : r.retref;
                payload.transactionType = this.state.paymentType;
                payload.memo = this.chargeMemo;

                payload.maskedCardNum = "xxxxxxxxxx" + (r && r.data && r.data.account ? r.data.account.slice(r.data.account.length - 4) : r.account.slice(r.account.length - 4));
                if (this.props.isTandemStudent) {
                    payload.isTandemStudent = this.props.isTandemStudent;
                }
                // no zipcode
                AccountStore.ChargeJumper(jumperId, payload);
                this.toggleModal();
                this.setState({ isloading: false });
            }
            else {
                // console.log("🚀 ~ file: ChargeJumper.js ~ line 598 ~ ChargeJumper ~ r", r)
                alert('something failed, please try again');
                this.setState({ isloading: false, errorOpen: true });
            }
        }

    }

    handleChargeResponse = (r) => {
        //var TransactionId = e.target.getAttribute("data-tid");
        const { transactionId } = this.state;

        if (r.Status === "Successful" && transactionId !== r.TransactionId) {
            var payload = {};
            var jumperId = this.PayLoadId;
            payload.amount = parseInt(this.PayLoadAmount);
            payload.transactionId = r.TransactionId;
            payload.transactionType = this.state.paymentType;
            payload.memo = this.chargeMemo;
            if (this.props.isTandemStudent) {
                payload.isTandemStudent = this.props.isTandemStudent;
            }
            AccountStore.ChargeJumper(jumperId, payload);
            this.toggleModal();
            this.setState({ isloading: false, transactionId: r.TransactionId });
        }
        else if (transactionId === r.TransactionId) {
            console.log('payment Done');
        }
        else {
            // swal({
            //     title: "Error",
            //     text: "Something failed, please try again",
            //     icon: "error",
            //     dangerMode: true,
            // });
            console.log('error while charge');
            this.setState({ isloading: false, errorOpen: true });
        }
    }

    renderRadio = () => {
        var options = [{ id: 1, nm: "Credit" }, { id: 2, nm: "Debit" }, { id: 3, nm: "Cash" }];

        const renderRadioGroup = options.map((item, i) => {
            return (
                <div key={item.id} onChange={(i) => this.callOptions(i)}>
                    <label className="radio-inline"><input type="radio" checked={this.state.checkedRadio == i} ref={(el) => this["myRadioRef" + i] = el} value={item.id} onChange={this.changeRadio} />{item.nm}</label>
                </div>
            );
        })
        return renderRadioGroup;
    }

    handleChangeRadio=(changeEvent)=> {
        var currentVal = changeEvent.target.dataset.key
        if (currentVal === "Card key in") {
            //document.getElementById("btn_CardkeyIn").click();
            // this.setState({
            //     showCredit: true
            // })
        }
        else if (currentVal.indexOf("Account-") > -1) {
            this.setState({
                paymentType: currentVal
            })
        }
        else {
            this.setState({
                showCredit: false
            })
        }
    }

    handleValidation=(name) =>{
        let fields = this.state;
        let errors = fields.errors;
        if (fields[name] === '') errors[name] = "This field is required";
        else if (name === 'amount' && !fields[name].match(/((\d+)(\.\d{2}))$/)) errors[name] = "Amount should be enter in two decimal places.";
        else errors[name] = "";
        this.setState({ errors: errors });
    }

    handleAmountInput = (event, key) => {
        var cache = { ...this.state };
        cache[key] = event.target.value;
        this.setState({ ...cache }, () => {
            this.handleValidation(key);
        });
    };


    toggleError=() =>{
        this.setState({
            errorOpen: !this.state.errorOpen
        });
    }

    generateYears = () => {
        var currYear = new Date().getFullYear();
        var yearsArray = [];
        for (let i = 0; i < 20; i++) {
            yearsArray.push(currYear + i);
        }
        return yearsArray;
    }

    handleInput = (event, key) => {
        var data = {};
        if (key === 'cardNumber' && event.target.value % 1 !== 0) {
            data["cardType"] = '';
            this.setState(data);
            return; // since we dont have numeric value
        }

        var cardnumber = event.target.value;
        var cardType = creditCardType(cardnumber);

        // this.cardDigit= event.target.value;
        if (cardnumber != '' && cardType.length > 0) {
            if (cardType.length > 0) {
                if (cardType[0].type == 'american-express') {
                    data["cardType"] = 'AmericanExpress';
                    data["cardIcon"] = 'amex';
                }
                else {
                    data["cardType"] = cardType[0].type;
                    data["cardIcon"] = 'amex';
                }
                if (cardType[0].type == 'visa') {
                    data["cardIcon"] = 'visa';
                }
                if (cardType[0].type == 'mastercard') {
                    data["cardIcon"] = 'mastercard';
                }
                if (cardType[0].type == 'discover') {
                    data["cardIcon"] = 'discover';
                }
            }
        }
        else {
            data["cardType"] = '';
        }

        data[key] = event.target.value;
        this.setState(data);
    };



    render() {
        const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
        `;

        var token = this.props.token;
        var accountOnFile = this.props.accountOnFile
        var cardNumber = '';
        if (token != undefined && token.length > 0) {
            var card = token[token.length - 1].cardNumLast4;
            cardNumber = card;
        }
        var accountNumber = '';
        if (accountOnFile != undefined && accountOnFile.length > 0) {
            var account = accountOnFile[accountOnFile.length - 1].AccountNumber;
            accountNumber = "ACH Payout - Account-" + account;
        }

        var paymentType = [];

        if (cardNumber != '') {
            paymentType = ["Credit", "Debit", cardNumber, "Cash", "Check", "Card key in", "Cash Payout", "Check Payout"];
        }

        else {
            paymentType = ["Credit", "Debit", "Cash", "Check", "Card key in", "Cash Payout", "Check Payout"];
        }
        if (accountNumber != '') {
            paymentType.push(accountNumber);
        }

        return (
            <React.Fragment>
                <ItemModal
                    isModalOpen={this.state.isModalOpen}
                    title={`Charge Jumper`}
                >

                    <div className='complete-loading'>
                        <ClipLoader
                            css={override}
                            sizeUnit={"px"}
                            size={35}
                            color={'#fff'}
                            loading={this.state.isloading}
                        />

                    </div>

                    <span id="btn_CardkeyIn" style={{ display: 'none' }}>
                        <NabVelocity
                            amount={1}
                            terminalProfileId={window.ENV?.processorInfo.paymentKey}
                            onProcessPayment={this.handleChargeResponse}
                            text="Card"
                        />
                    </span>

                    <LocalForm onSubmit={(values) => this.handleSubmit(values)}>

                        <Row className="form-group">
                            <Label htmlFor="pilot" md={4}>Enter Amount :</Label>
                            <Col md={8}>
                                <Control.input name="amount" model=".amount" className="form-control"
                                    mapProps={{ onChange: (props) => props.onChange }} defaultValue={this.props.value}
                                    onChange={(e) => this.handleAmountInput(e, 'amount')} autoComplete="off" />
                                <span className="text-danger error-validation">{this.state.errors["amount"]}</span>
                            </Col>
                        </Row>

                        <Row className="form-group">
                            <Label htmlFor="pilot" md={4}>memo (optional) :</Label>
                            <Col md={8}>
                                <Control.input name="memo" model=".memo" className="form-control"
                                    mapProps={{ onChange: (props) => props.onChange }} autoComplete="off" />
                            </Col>
                        </Row>


                        <Row className="form-group">
                            <Label htmlFor="pilot" md={4}>Payment Type:</Label>
                            <Col md={8}>
                                {
                                    paymentType.map((i) =>
                                        <div className="col" key={i}>
                                            <input
                                                onChange={(d) => this.setState({ paymentType: i.replace('ACH Payout - ',''), isSelected: true })}
                                                //onChange= {this.handleChangeRadio}
                                                onClick={this.handleChangeRadio}
                                                name="payymentType"
                                                type="radio"
                                                data-key={i}
                                                checked={this.state.paymentType ===  i.replace('ACH Payout - ','')}
                                            /> {i}
                                        </div>
                                    )
                                }
                            </Col>
                        </Row>

                        {
                            this.state.showCredit ?
                                <div>
                                    <Row className="form-group">

                                        <Label htmlFor="cardNumber" md={3}>Card Number</Label>
                                        <Col md={9}>

                                            <input
                                                type="text"
                                                className="invoiceFrom form-control"
                                                name="cardNumber"
                                                placeholder=""
                                                onChange={(e) => this.handleInput(e, 'cardNumber')} />
                                        </Col>
                                    </Row>

                                    <Row className="form-group">
                                        <Label htmlFor="cardNumber" md={3}>Expiry</Label>

                                        <Col md={3}>
                                            <select onChange={this.handleMonthSelect} name='month' model=".month" className="invoiceFrom form-control" style={{ width: '100%' }} >
                                                <option>MM</option>
                                                {this.months.map((item, i) => <option key={i} value={(i + 1)}>{item}</option>)}
                                            </select>

                                        </Col>



                                        <Col md={3}>
                                            <select onChange={this.handleYearSelect} name="year" model=".year" className="invoiceFrom form-control" style={{ width: '100%' }} >
                                                <option>YY</option>
                                                <option value="2015">2015</option>
                                                {this.generateYears().map((item) => <option key={item} value={item}>{item}</option>)}
                                            </select>
                                        </Col>
                                    </Row>

                                    <Row className="form-group">
                                        <Label htmlFor="cardNumber" md={3}>Cvv</Label>
                                        <Col md={8}>
                                            {/* <label className="invoiceFormLabel" data-toggle="tooltip" title="" data-original-title="3 digits code on back side of the card">CVV</label> */}
                                            <Control.input name="cvv" model=".cvv" className="form-control" style={{ width: '40%' }}
                                                mapProps={{ onChange: (props) => props.onChange }} autoComplete="off" />
                                        </Col>
                                    </Row>

                                    {
                                        <Row className="form-group">
                                            <Col md={8}>

                                                {
                                                    this.state.cardType != '' ?
                                                        <PaymentIcon
                                                            id={this.state.cardIcon}
                                                            style={{ margin: 10, width: 100 }}
                                                            className="payment-icon"
                                                        />
                                                        : ''
                                                }
                                            </Col>
                                        </Row>
                                    }
                                </div>
                                : ''
                        }

                        <Row className="form-group m-t-2-rem">
                            <Col md={{ size: 9 }}>
                                {
                                    this.state.isSelected && !this.state.isloading ?
                                        <button className="btn btn-bg lightColor createButton" type="submit" >SUBMIT</button>
                                        :
                                        <button className="btn btn-bg lightColor createButton" type="submit" disabled>SUBMIT</button>
                                }
                                <button type="button" id="btn_ChargeResponse" style={{ display: 'none' }} onClick={(e) => this.handleChargeResponse(e)}></button>
                                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">CANCEL</button>
                            </Col>
                        </Row>
                    </LocalForm>
                </ItemModal>
                {/* <Modal isOpen={this.state.errorOpen} toggle={this.toggleError} className={this.props.className}>
                    <ModalHeader toggle={this.toggleError} className="error-jumperHeader">
                       Warning
                    </ModalHeader>
                    <ModalBody>
                        <p style={{ color: 'red', fontSize: '20px', marginLeft: '1%' }}>Something Wrong happened while charging Jumper !</p>
                    </ModalBody>
                </Modal> */}
                <button className="btn customButton rightButton" style={{ borderRadius: '4px', backgroundColor: '#A7F6FF', color: '#082764' }} onClick={this.toggleModal}>
                    CHARGE/PAY JUMPER
                </button>
            </React.Fragment>
        );
    }
}

export default ChargeJumper
